// removed by extract-text-webpack-plugin
module.exports = {"PhotoInfo":"PhotoInfo","PhotoInfo__btn__open__wrap":"PhotoInfo__btn__open__wrap","PhotoInfo__btn__open":"PhotoInfo__btn__open","PhotoInfo__content":"PhotoInfo__content","is-open":"is-open","PhotoInfo__container":"PhotoInfo__container","PhotoInfo__text":"PhotoInfo__text","PhotoInfo__btn__close":"PhotoInfo__btn__close","link__color__dark":"link__color__dark","link__color__light":"link__color__light","is-show-scroll_btn":"is-show-scroll_btn","is-hide-scroll_btn":"is-hide-scroll_btn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/photo-info/styles.css
// module id = 742
// module chunks = 0 1